export default __webpack_public_path__ + "static/media/sales_banner_2.41cef383.png";